<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-consignee"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new consignee</small
                >
              </legend>
              <form @submit.prevent="newConsignee()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Consignee name</label>
                      <input
                        type="text"
                        class="form-control consignee_name"
                        placeholder="consignee name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number</label>
                      <input
                        type="text"
                        class="form-control phone_number"
                        placeholder="phone number"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingConsignee"
                >
                  <i class="fa fa-plus"></i> Add consignee
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingConsigneeLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="update-consignee"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Update -- {{ Consignee.consignee_name }}</small
                >
              </legend>
              <form @submit.prevent="consigneeUpdate()">
                <div class="row">
                    <input type="hidden" class="id" :value="Consignee.id">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Consignee name</label>
                      <input
                        type="text"
                        class="form-control Uconsignee_name"
                        placeholder="consignee name"
                        :value="Consignee.consignee_name"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Phone number</label>
                      <input
                        type="text"
                        class="form-control Uphone_number"
                        placeholder="phone number"
                        :value="Consignee.phone_number"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat updatingConsignee"
                >
                  <i class="fa fa-plus"></i> Update consignee
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat updatingConsigneeLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >Manage consignees</small
        >
      </legend>
      <button
        type="button"
        class="btn btn-primary btn-roundec"
        data-toggle="modal"
        data-target="#new-consignee"
      >
        <i class="fa fa-plus"></i> new consignee
      </button>
      <p></p>
      <div></div>
      <div>
        <div class="consigneesLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >loading consignees...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemConsignees"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'rows per page',
            ofLabel: 'of',
            pageLabel: 'page', //for 'pages' mode
            allLabel: 'all',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                class="btn btn-info btn-sm btn-block"
                @click="viewConsignee(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit consignee
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { newConsignee } from "../routes/routes";
export default {
  data() {
    return {
      columns: [
        {
          label: "Consignee name",
          field: "consignee_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter consignee name",
          },
        },
        {
          label: "Phone number",
          field: "phone_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter phone number",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadConsignees();
  },
  computed: {
    ...mapGetters(["systemConsignees", "Consignee"]),
  },
  methods: {
    ...mapActions([
      "loadConsignees",
      "newConsignee",
      "viewConsignee",
      "consigneeUpdate",
    ]),
  },
};
</script>
<style scoped>
.creatingConsigneeLoader {
    display: none
}
.updatingConsigneeLoader {
    display: none
}
</style>


// WEBPACK FOOTER //
// src/consignees/manageconsignees.vue